export default "__VITE_PUBLIC_ASSET__b33846d6__"